import React from "react";
import "./style.scss";

interface InitialAvatarProps {
  initials: string;
}

const InitialAvatar: React.FC<InitialAvatarProps> = ({ initials }) => {
  return (
    <div className="avatar-card">
      <div className="avatar-body">{initials}</div>
    </div>
  );
};

export default InitialAvatar;
